import script from "./number-box-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./number-box-field.vue?vue&type=script&setup=true&lang=ts"

import "./number-box-field.vue?vue&type=style&index=0&id=c4c6b7b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4c6b7b2"]])

export default __exports__